import type { QueuedOperation, QueueStorage, RejectedOperation } from "./queue.ts";

/**
 * The backing the tests and any server-side consumer use.
 *
 * The IndexedDB one lives at `@tovi/pos-sync/indexeddb` rather than here, so
 * that importing this package from a Node or Bun process does not drag DOM
 * types in behind it. The till imports the subpath; nothing else needs to.
 */

export class MemoryQueueStorage implements QueueStorage {
  #rows = new Map<string, QueuedOperation>();
  #dead = new Map<string, RejectedOperation>();

  async all(): Promise<QueuedOperation[]> {
    return [...this.#rows.values()];
  }

  async put(operation: QueuedOperation): Promise<void> {
    this.#rows.set(operation.id, operation);
  }

  async remove(id: string): Promise<void> {
    this.#rows.delete(id);
  }

  async reject(entry: RejectedOperation): Promise<void> {
    this.#dead.set(entry.operation.id, entry);
  }

  async rejected(): Promise<RejectedOperation[]> {
    return [...this.#dead.values()];
  }

  async clearRejection(id: string): Promise<void> {
    this.#dead.delete(id);
  }
}
